import { User } from "../@core/data/users";

export default class ReportSpam {
  id?: string;
  mode?: string;
  refId?: string;
  refTitle?: string;
  refUid?: string;
  refAuthor?: User;
  refApproved?: boolean;

  refDescription?: string;
  refUrl?: string;

  value?: number;
  reason?: string;
  courseId?: string;

  noLiked?: number;
  noComment?: number;

  isTrusted?: boolean;
  isConfirmed?: boolean;
  confirmedOn?: Date;
  confirmedBy?: string;
  confirmedAuthor?: User;

  //render
  iconMode?: string;
  navigateUrl?: string;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
